<template>
    <div class="c2">
        <div class="c2-content">
            <div class="text-area" ref="content" @mouseenter="mouseenterEvent()" @mouseleave="mouseleaveEvent()">
                <div class="list-content" ref="scroll1">
                    <div class="list-item" v-for="(item, i) in defaultdata" :key="i">
                        <div class="_Ranking">
                            {{ i + 1 }}
                        </div>
                        <div class="text" :style="{
                            width: textnum[i] + 'px',
                            color: i > 1 ? '#4EA3E6' : '',
                        }" v-for="(del, i) in valueMap" :key="i">
                            <span :title="item[del.key]">{{ item[del.key] }}</span>
                        </div>
                    </div>
                </div>
                <div class="list-content" ref="scroll3">
                    <div class="list-item" v-for="(item, i) in defaultdata" :key="i">
                        <div class="_Ranking">
                            {{ i + 1 }}
                        </div>
                        <div class="text" :style="{
                            width: textnum[i] + 'px',
                            color: i > 1 ? '#4EA3E6' : '',
                        }" v-for="(del, i) in valueMap" :key="i">
                            <span :title="item[del.key]">{{ item[del.key] }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as methods from "./method.js";
export default {
    name: "template.scope74",
    props: {
        vdata: {
            type: Array,
            default: () => [],
        },
        jsondata: {
            type: [Array, String],
            default: () => [],
        },
        valuemap: {
            type: [Array, String],
            default: () => [],
        },
    },
    data() {
        return {
            title: "scope8-【组件】轮播5组表格样式1-完成",
            isList: true,
            textnum: 127,
            timer: null,
            defaultdata: [
                { value1: "文本一", value2: "数值一", value3: "单位一" },
                { value1: "文本二", value2: "数值二", value3: "单位二" },
                { value1: "文本三", value2: "数值三", value3: "单位三" },
                { value1: "文本四", value2: "数值四", value3: "单位四" },
                { value1: "文本五", value2: "数值五", value3: "" },
                { value1: "文本六", value2: "数值六", value3: "" },
                { value1: "文本七", value2: "数值七", value3: "" },
                { value1: "文本八", value2: "数值八", value3: "" },
            ],
            valueMap: [
                { name: "名称", key: "value1" },
                { name: "数值", key: "value2" },
                { name: "单位", key: "value3" },
            ],
            exceldata: [],
        };
    },
    watch: {
        vdata(n) {
            if (n && n.length) {
                const box = this.$refs.content;
                box.scrollTop = 0;
                this.defaultdata = n;
            }
        },
        valuemap(n) {
            if (n && n.length) {
                const box = this.$refs.content;
                box.scrollTop = 0;
                this.valueMap = n;
                this.getWidth();
            }
        },
        jsondata(n) {
            this.exceldata = n;
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.rollUp(150);
        });
        if (this.valuemap && this.valuemap.length) {
            this.valueMap = this.valuemap;
        }
        if (this.vdata && this.vdata.length) {
            this.defaultdata = this.vdata;
        }
        this.setData()
        this.getWidth();
    },
    methods: {
        ...methods,
        rollUp(t) {
            const ulf1 = this.$refs.scroll1;
            const box = this.$refs.content;
            if (ulf1.offsetHeight > 120) {
                box.scrollTop = 0;
                this.timer = setInterval(this.rollStart, t);
            } else if (ulf1.offsetHeight == 0) {
                setTimeout(() => {
                    this.rollUp(150);
                }, 200);
            }
        },
        rollStart() {
            const ulf1 = this.$refs.scroll1;
            const box = this.$refs.content;
            if (box.scrollTop >= ulf1.scrollHeight) {
                box.scrollTop = 0;
            } else {
                box.scrollTop += 2;
            }
        },
        mouseenterEvent() {
            if (this.timer) {
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        mouseleaveEvent(t) {
            if (!this.timer) {
                this.timer = setInterval(this.rollStart, 150);
            }
        },
        // getWidth() {
        //   const headnum = this.valueMap.length;
        //   const rankNum = this.valueMap.filter((item) => item.isRank).length;
        //   if (headnum) {
        //     // this.textnum = (435 - 20) / (headnum - rankNum)
        //     this.textnum = 435 / (headnum - rankNum);
        //   } else {
        //     setTimeout(() => {
        //       this.getWidth();
        //     }, 200);
        //   }
        //   // console.log('__getwidth', this.textnum)
        // },
        getWidth() {
            const headnum = this.valueMap.length;
            // 定义总宽度
            const totalWidth = 435;

            if (headnum === 3) {
                // 计算第二项的宽度
                const secondWidth = totalWidth * 0.25;
                // 计算第三项的宽度
                const thirdWidth = totalWidth * 0.15;
                // 计算第一项的宽度，即总宽度减去第二项和第三项的宽度
                const firstWidth = totalWidth - secondWidth - thirdWidth;

                // 这里假设 textnum 是一个数组，按顺序存储各项宽度
                this.textnum = [firstWidth, secondWidth, thirdWidth];
            } else {
                // 若数组长度不为 3，可选择递归调用或进行其他处理
                setTimeout(() => {
                    this.getWidth();
                }, 200);
            }
            // 打印结果，方便调试
            // console.log("__getwidth", this.textnum);
        },
    },
    beforeDestroy() {
        clearInterval(this.timer);
        this.timer = null;
    },
};
</script>

<style scoped lang="scss">
.c2 {
    width: 435px;
    height: 240px;
    margin: 0px auto 0 auto;
    position: relative;
    overflow: hidden;
    pointer-events: auto;
    cursor: pointer;
    padding: 10px 0;

    .text {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 14px;
        line-height: 14px;
        padding: 0 4px;
        box-sizing: border-box;
        // width: 103px;
        max-width: 100%;
        overflow: hidden;
        text-align: center;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        text-overflow: ellipsis;

        img {
            width: 23px;
            height: 19px;
        }
    }

    .list-item {
        display: flex;
        align-items: center;
        padding: 12px 0;
        min-height: 20px;
        margin: 4px 0;
        // background: rgba(59, 120, 177, 0.05);
        background: #062e51;

        .text {
            color: #c6d2d8;
        }

        &:nth-child(2n + 1) {
            // background: rgba(59, 120, 177, 0.16);
            background: #041c38;
        }
    }

    .text-area {
        pointer-events: auto;
        max-height: 240px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 0;
        }
    }

    .c2-content {
        height: 100%;
    }
}

._Ranking {
    width: 33px;
    height: 17px;
    margin: 0 20px 0 20px;
    background: #104465;
    display: flex;
    justify-content: center;
    align-items: center;
    // padding-top: 2px;
    box-sizing: border-box;

    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #81b3ce;
    line-height: 14px;
    font-style: italic;
}

.list-item:nth-child(1) {
    ._Ranking {
        background: #5b5336;
        color: #faf3b9;
    }
}

/* 设置第一组和第三组文字左对齐，第二组文字右对齐 */
.list-item .text:nth-child(3) {
    text-align: right;
    font-family: Source Han Sans CN;
    font-weight: 500;
    font-size: 14px;
    color: #0db9fc;
    line-height: 15px;
}

.list-item .text:nth-child(2),
.list-item .text:nth-child(4) {
    text-align: left;
    font-family: Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #cee8fd !important;
    line-height: 15px;
}
</style>